'use client';

import { createContext, ReactNode } from 'react';
import { useMedia } from 'react-use';

interface IsMobileProviderProps {
  children: ReactNode;
}
export const IsMobileContext = createContext(false);

export default function IsMobileProvider({ children }: IsMobileProviderProps) {
  const isMobile = useMedia('(max-width: 1024px)', false);
  return <IsMobileContext.Provider value={isMobile}>{children}</IsMobileContext.Provider>;
}
